import firebase from "firebase/app";

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import deleteDistribution from "astrid-firestore/src/api/distribution/deleteDistribution";

import useDistributionDropdownMenuOptions from "../../../../distribution/hooks/useDistributionDropdownMenuOptions";
import useDistributionsTableColumns from "../../../../distribution/hooks/useDistributionsTableColumns";
import { getOrganizationPath } from "../../../../routing/utils/getOrganizationPath";
import Table from "../../../../tables/components/Table";
import Button from "../../../../ui/components/Buttons/Button";
import ConfirmationModalTrigger from "../../../../ui/components/ConfirmationModal/ConfirmationModalTrigger";

export default function ArticleDistributionsTable({ article, distributions }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const sorted = distributions
		? [...distributions].sort((a, b) => (a.channel?.name ?? "").localeCompare(b.channel?.name ?? ""))
		: distributions;

	const columns = useDistributionsTableColumns({ showPublisher: false });
	const getDropdownMenuOptions = useDistributionDropdownMenuOptions({ article });

	const onClearAll = async () => {
		for (const distribution of distributions) {
			await deleteDistribution(firebase, { distribution });
		}
	};

	return (
		<>
			<Table
				data={sorted ?? []}
				columns={columns}
				allowEmpty
				getDropdownMenuOptions={getDropdownMenuOptions}
				onClick={(row) => navigate(getOrganizationPath(`/distributions/${row.id}`))}
			/>

			<div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5em", marginTop: "0.75em" }}>
				<ConfirmationModalTrigger
					disabled={!distributions}
					header={t("clearAllDistributions", "Clear all distributions?")}
					text={t(
						"clearAllDistributionsConfirm",
						"This will delete all distribution records for this article. This action cannot be undone.",
					)}
					onConfirm={onClearAll}
					trigger={
						<Button negative size="small">
							{t("clearAll", "Clear all")}
						</Button>
					}
				/>
			</div>
		</>
	);
}
